module.exports = __webpack_public_path__ + "img/copy.3966be5f.png";